import { render, staticRenderFns } from "./WatchersTab.vue?vue&type=template&id=fdc5060e&scoped=true"
import script from "./WatchersTab.vue?vue&type=script&lang=js"
export * from "./WatchersTab.vue?vue&type=script&lang=js"
import style0 from "./WatchersTab.vue?vue&type=style&index=0&id=fdc5060e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc5060e",
  null
  
)

export default component.exports